import {TextField} from "@mui/material";
import {InputWithLabel} from "../../create-question-modal";
import React, {useEffect} from "react";
import {FileTypeSelector} from "./file-type-selector";


export const FileUploadQuestion = ({question, onChange, onUpdate}) => {

  useEffect(() => {
    if (question?.max_files === undefined) {
      onUpdate("max_files", 1);
    } else if (question?.max_file_size === undefined) {
      onUpdate("max_file_size", 5);
    }
  }, [question?.max_files, question?.max_file_size]);

  return (
    <>
      <FileTypeSelector selected={question?.file_types || []} setSelected={(types) => onUpdate("file_types", types)} />
      <InputWithLabel label={"Maximum Number of Files:"}>
        <TextField
          value={+question?.max_files || ""} onChange={onChange} name={"max_files"} disabled={!!question?.originalReferenceUid}
          type={"number"} fullWidth placeholder={"1"}
          InputProps={{ inputProps: { min: 1, max: 20 } }}
          helperText={question?.max_files > 20 || question?.max_files < 1 ? "Please set the maximum number of files between 1 and 20" : question?.max_files > 5 ? "Please note: Many files will cause a longer wait time for the survey to submit" : "Please note: You can upload up to 20 files. Be aware that submitting many files may result in longer processing times."}
          required error={!question?.max_files || question?.max_files > 20}
        />
      </InputWithLabel>
      <InputWithLabel label={"Maximum Size Per File (megabytes)"}>
        <TextField
          value={question?.max_file_size || ""} onChange={onChange} name={"max_file_size"} disabled={!!question?.originalReferenceUid}
          InputProps={{ inputProps: { min: 1, max: 100 } }}
          type={"number"} fullWidth placeholder={"5mb"} helperText={question?.max_file_size > 100 ? "Please set the maximum file size at 100mb or smaller." : question?.max_file_size > 5 ? "Please note: Large file sizes will cause a longer wait time for the survey to submit" : "Please note: The file size limit is 100MB. Uploading larger files may result in longer submission times."}
          required error={!question?.max_file_size || question?.max_file_size > 100}
        />
      </InputWithLabel>
    </>
  )
}